// extracted by mini-css-extract-plugin
export default {"container":"CampaignArtistPillButtons_container__GHKt+"};